import React, { useEffect, useState } from "react";
import { Button, Col, Row, Spinner } from "react-bootstrap";
import { fetchReportGoals, fetchReportTasks } from "../../services/httpClient";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faDownload } from "@fortawesome/free-solid-svg-icons";
import html2canvas from "html2canvas";
import ReportTimeInterval from "./ui/ReportTimeInterval";
import { GoalsCompletedMetric } from "./charts-metrics/GoalsCompletedMetric";
import { TasksCompletedMetric } from "./charts-metrics/TasksCompletedMetric";
import { GoalsCompletedTable } from "./charts-metrics/GoalsCompletedTable";
import { TasksCompletedTable } from "./charts-metrics/TasksCompletedTable";

const GoalsAndTasksTab = ({ buildPDF, canvas, setCanvas, iPad }: any) => {
  const [isLoading, setIsLoading] = useState<boolean>(true);
  const [startDate, setStartDate] = useState<string>();
  const [endDate, setEndDate] = useState<string>();
  const [dateInterval, setDateInterval] = useState<number>(365);
  const [goalData, setGoalData] = useState<any>([]);
  const [taskData, setTaskData] = useState<any>([]);
  const [reportRunning, setReportRunning] = useState<boolean>(false);

  useEffect(() => {
    const start = new Date();
    start.setDate(start.getDate() - dateInterval);
    setStartDate(start.toISOString().slice(0, 10));
    setEndDate(new Date().toISOString().slice(0, 10));
    getGoalsAndTasks(start.toISOString().slice(0, 10), new Date().toISOString().slice(0, 10));
  }, []);

  useEffect(() => {
    if (reportRunning) {
      buildPDF();
      setReportRunning(false);
    }
  }, [canvas]);

  const getGoalsAndTasks = (start: string, end: string) => {
    fetchReportGoals(start, end)
      .then((res: any) => {
        const goals = res[0].data;
        const sortedGoals = goals.sort((a: any, b: any) => (a.completed_at < b.completed_at ? 1 : -1));
        setGoalData(sortedGoals);

        fetchReportTasks(start, end).then((res: any) => {
          const tasks = res[0].data;
          const sortedTasks = tasks.sort((a: any, b: any) => (a.cm_reviewed_at < b.cm_reviewed_at ? 1 : -1));
          setTaskData(sortedTasks);
        });
      })
      .catch((err: any) => {
        console.log(err);
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  const downloadReport = async () => {
    setReportRunning(true);
    const reportSection = document.getElementById("goals-section");
    const reportTitle = document.getElementById("goals-title");
    const refreshButton = document.getElementById("goals-refresh-button");
    const downloadGoalsButton = document.getElementById("download-goals-button");
    const downloadTasksButton = document.getElementById("download-tasks-button");

    if (reportSection) {
      if (reportTitle) {
        reportTitle.style.visibility = "hidden";
        reportTitle.style.display = "none";
      }
      if (refreshButton) refreshButton.style.visibility = "hidden";
      if (downloadGoalsButton) downloadGoalsButton.style.visibility = "hidden";
      if (downloadTasksButton) downloadTasksButton.style.visibility = "hidden";

      const images = reportSection.getElementsByTagName("img");
      for (let i = 0; i < images.length; i++) {
        images[i].crossOrigin = "anonymous";
      }

      const canvas = await html2canvas(reportSection, { useCORS: true });
      setCanvas(canvas);

      if (reportTitle) {
        reportTitle.style.visibility = "visible";
        reportTitle.style.display = "flex";
      }
      if (refreshButton) refreshButton.style.visibility = "visible";
      if (downloadGoalsButton) downloadGoalsButton.style.visibility = "visible";
      if (downloadTasksButton) downloadTasksButton.style.visibility = "visible";
    } else {
      console.error("Report section not found");
      setReportRunning(false);
    }
  };

  return (
    <div id="goals-section">
      {isLoading ? (
        <div className="text-center mt-5">
          <Spinner animation="border" style={{ color: "#F6893D" }} />
        </div>
      ) : (
        <>
          <Row id="goals-title" className="mb-2">
            <Col className="col-8">
              <h4 className="hero-heading app-header-text">Goals and Tasks</h4>
            </Col>
            <Col className="text-end col-4">
              {!iPad && (
                <Button className="app-primary-color button" onClick={() => downloadReport()}>
                  <FontAwesomeIcon icon={faDownload} />
                  {" Report"}
                </Button>
              )}
            </Col>
          </Row>
          <ReportTimeInterval
            startDate={startDate}
            setStartDate={setStartDate}
            endDate={endDate}
            setEndDate={setEndDate}
            dateInterval={dateInterval}
            setDateInterval={setDateInterval}
            intervalOne={30}
            intervalOneText={"30 Days"}
            intervalTwo={90}
            intervalTwoText={"90 Days"}
            intervalThree={180}
            intervalThreeText={"180 Days"}
            intervalFour={365}
            intervalFourText={"Last Year"}
            onClickRefresh={getGoalsAndTasks}
            hideBtnId="goals-refresh-button"
          />
          <Row className="mt-3 mb-3">
            <Col></Col>
            <Col className="col-3">
              <GoalsCompletedMetric data={goalData.length} />
            </Col>
            <Col className="col-3">
              <TasksCompletedMetric data={taskData.length} />
            </Col>
            <Col></Col>
          </Row>
          {goalData.length > 0 && (
            <GoalsCompletedTable data={goalData} />
          )}
          {taskData.length > 0 && (
            <TasksCompletedTable data={taskData} />
          )}
        </>
      )}
    </div>
  );
};

export default GoalsAndTasksTab;
